import {
	SET_FORM_STATE_ERICSSON, SET_FORM_STATE_NOKIA, SET_FORM_STATE_VALUES, SET_DETAILS
} from '../actions/ManagementActions';

const initialState = {
	formStateEricsson:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
	formStateNokia:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
	teamDetails: {}
};

const managementReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE_ERICSSON: {
						return {
							...state,
							formStateEricsson: action.formStateEricsson
						};
					}
					case SET_FORM_STATE_NOKIA: {
						return {
							...state,
							formStateNokia: action.formStateNokia
						};
					}
					case SET_DETAILS: {
						return {
							...state,
							teamDetails: action.teamDetails
						};
					}
					case SET_FORM_STATE_VALUES: {
						return {
							...state,
							formStateEricsson: {
								...state.formStateEricsson,
								values: { ...action.teamAssingValues[0] }
							},
							formStateNokia: {
								...state.formStateNokia,
								values: { ...action.teamAssingValues[1] }
							}
						};
					}
					default: {
						return state;
					}
	}
};

export default managementReducer;
